// Thin wrapper around Shopify's native Ajax Cart endpoints. Every call goes
// through one module-scoped promise chain, so however many add/change calls
// fire in quick succession, only one is ever in flight — no concurrent
// requests, no out-of-order responses, no per-element state to lose track
// of if the calling element gets recreated. Returns plain cart JSON only —
// no `sections` param, so the server does no Liquid rendering on these
// calls and the client never has to parse an HTML response.
window.FlixCartAPI = (function () {
  var chain = Promise.resolve();

  function enqueue(task) {
    var result = chain.then(task, task);
    chain = result.catch(function () {});
    return result;
  }

  function request(path, body) {
    return fetch(window.Shopify.routes.root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) {
          var err = new Error(data.description || data.message || 'Cart request failed');
          err.data = data;
          throw err;
        }
        return data;
      });
    });
  }

  function getCart() {
    return fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); });
  }

  return {
    // /cart/add.js's response is the added line(s) only — never the full
    // cart (item_count, total_price, every line) the way /cart/change.js
    // and /cart.js respond. A follow-up GET inside the same queued task
    // (so nothing else can interleave between the two) gets the caller the
    // one shape renderCart actually needs, every time, from one call site.
    add: function (variantId, quantity) {
      return enqueue(function () {
        return request('cart/add.js', { items: [{ id: variantId, quantity: quantity }] }).then(getCart);
      });
    },
    change: function (lineKey, quantity) {
      return enqueue(function () {
        return request('cart/change.js', { id: lineKey, quantity: quantity });
      });
    },
    get: function () {
      return enqueue(getCart);
    }
  };
})();
